// src/pages/mission/components/SquadRosterPanel.jsx

import React from 'react';
import { Users } from 'lucide-react';
import { getColorClasses } from '../../themeConfig';
import { getSoldierClass, formatSoldierName } from '../Mission.utils';

const SquadRosterPanel = ({ squad, selectedSoldier, onSelectSoldier, primaryColor }) => {
  return (
    <div className="bg-gray-800 border border-gray-700 rounded-lg p-6">
      <h2 className="text-xl font-bold mb-4 flex items-center gap-2">
        <Users className="text-green-400" />
        Deployment Roster
      </h2>
      <div className="space-y-2">
        {squad.map(soldier => {
          const soldierClass = getSoldierClass(soldier);
          const isSelected = selectedSoldier?.id === soldier.id;
          
          return (
            <button
              key={soldier.id}
              onClick={() => onSelectSoldier(soldier)}
              className={`w-full text-left p-3 rounded-lg border-2 transition-all ${
                isSelected
                  ? `${getColorClasses(primaryColor, 'bg')} ${getColorClasses(primaryColor, 'border')}`
                  : 'bg-gray-700 border-gray-600 hover:border-gray-500'
              }`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <div className="flex items-center gap-2">
                    <p className="font-bold">{formatSoldierName(soldier)}</p>
                    {soldierClass && (
                      <span className="text-lg">{soldierClass.icon}</span>
                    )}
                  </div>
                  <div className="flex items-center gap-2">
                    <p className="text-xs text-gray-400">{soldier.rank}</p>
                    {soldierClass && (
                      <p className="text-xs text-purple-400">{soldierClass.name}</p>
                    )}
                  </div>
                  {soldier.experience !== undefined && (
                    <p className="text-xs text-gray-500 mt-1">XP: {soldier.experience}</p>
                  )}
                </div>
                <div className="text-right">
                  <div className="w-20 bg-gray-600 rounded-full h-1.5 mb-1">
                    <div 
                      className="h-1.5 rounded-full bg-green-500"
                      style={{ 
                        width: `${((soldier.health || 100) / (soldier.max_health || 100)) * 100}%` 
                      }}
                    />
                  </div>
                  <p className="text-xs text-gray-400">
                    {soldier.health || 100}/{soldier.max_health || 100} HP
                  </p>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SquadRosterPanel;